import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const dateTimeOptions = {
  short: {
    month: 'short',
    day: 'numeric'
  },
  shortWithYear: {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  },
  long: {
    month: 'long',
    day: 'numeric'
  },
  longWithYear: {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  },
  time: {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  },
  weekdayOnly: {
    weekday: 'short'
  },
  dateOnly: {
    day: 'numeric'
  },
  yearOnly: {
    year: 'numeric'
  },
  monthOnly: {
    month: 'long'
  },
  dateMonth: {
    month: 'long',
    year: 'numeric'
  }
}

export default new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
  dateTimeFormats: {
    en: dateTimeOptions
  }
})
